import type { OpenGraphData } from "../../logic/SitePresenter/SitePresenter";
import logo from "./logo.png";

const getImageUrl = (domain: string) => {
	const imagePath = typeof logo === "string" ? logo : logo.src;
	return new URL(imagePath, domain).toString();
};

const OpenGraphProperty = ({ property, content }: { property: string; content: string }) => {
	return <meta content={content} property={`og:${property}`} />;
};

const OpenGraph = ({
	openGraphData,
	domain,
	basePath,
}: {
	openGraphData: OpenGraphData;
	domain: string;
	basePath: string;
}) => {
	const toUrl = (pathname: string) => domain + basePath + pathname;
	const pageUrl = openGraphData?.pathname ? toUrl(openGraphData.pathname) : "";
	return (
		<>
			<OpenGraphProperty content={openGraphData?.title ?? ""} property="title" />
			<OpenGraphProperty content="article" property="type" />
			<OpenGraphProperty content={getImageUrl(domain)} property="image" />
			<OpenGraphProperty content="64" property="image:width" />
			<OpenGraphProperty content="64" property="image:height" />
			<OpenGraphProperty content={openGraphData?.description ?? ""} property="description" />
			{pageUrl && (
				<>
					<OpenGraphProperty content={pageUrl} property="url" />
					<link href={pageUrl} rel="canonical" />
				</>
			)}
			{openGraphData?.alternates.map(({ hreflang, pathname }) => (
				<link href={toUrl(pathname)} hrefLang={hreflang} key={hreflang} rel="alternate" />
			))}
		</>
	);
};

export default OpenGraph;
